var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#24C69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#24C69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.974h-6V27H27v4.474c0 .275-.225.5-.5.5ZM19.5 26H13v-4.526c0-.275.225-.5.5-.5h6V26Zm0 5.974h-6a.501.501 0 0 1-.5-.5V27h6.5v4.974Zm1-11h6c.275 0 .5.225.5.5V26h-6.5v-5.026Zm6-1h-13c-.826 0-1.5.673-1.5 1.5v10c0 .827.674 1.5 1.5 1.5h13c.828 0 1.5-.673 1.5-1.5v-10c0-.827-.672-1.5-1.5-1.5Z",
    fill: "#FFF"
  }))));
};
export default SvgExcel;